import { render, staticRenderFns } from "./newPlayer2.vue?vue&type=template&id=296cad5a&scoped=true"
import script from "./newPlayer2.vue?vue&type=script&lang=js"
export * from "./newPlayer2.vue?vue&type=script&lang=js"
import style0 from "./newPlayer2.vue?vue&type=style&index=0&id=296cad5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296cad5a",
  null
  
)

export default component.exports